import LocalizedStrings from "react-localization";

export const viewMappingDetailsStrings = new LocalizedStrings({
  en: {
    preview: "Preview",
    detail: "Detail",
    prevButton: "Prev",
    nextButton: "Next",
  },
  fr: {
    preview: "Aperçu",
    detail: "Détail",
    prevButton: "Préc",
    nextButton: "Suiv",
  },
});
